<div class="container-fluid mb-5 px-3">
    <div class="row justify-content-between align-items-center mb-3">
        <div class="w-fit">
            <app-back-button routerLink="/reservations/import" component="Select File"></app-back-button>
        </div>
    </div>
    <div class="mt-3 d-flex justify-content-between">
        <div class="font-weight-bold">
            <h1>Review Import Data</h1>
        </div>
    </div>
    <mat-card class="mt-3 pb-5">
        <div class="row justify-content-end p-3">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                    <ng-container matColumnDef="booking_id">
                        <mat-header-cell *matHeaderCellDef>Reference ID</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{ row['Booking ID'] }} <span *ngIf="row.showReservationFlag" class="required-input">*</span></mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="policy_id">
                        <mat-header-cell *matHeaderCellDef>Policy ID</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{ row['Policy ID'] }} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="organization_id">
                        <mat-header-cell *matHeaderCellDef>Organization ID</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ this.organizationId }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="unit_id">
                        <mat-header-cell *matHeaderCellDef>Property Reference ID</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row['Unit ID'] }} <span *ngIf="row.showPropertyFlag" class="required-input">*</span></mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="property_name">
                        <mat-header-cell *matHeaderCellDef>Property Name</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row['Property Name'] }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="booking_date">
                        <mat-header-cell *matHeaderCellDef>Booking Date</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row['Reported'] | date: 'mediumDate' }} <span *ngIf="row.missingDateFields?.includes('Reported')" class="required-input">*</span></mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="accommodation_start_date">
                        <mat-header-cell *matHeaderCellDef>Arrival Date</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{ row['Accommodation Start Date'] | date: 'mediumDate' }} <span *ngIf="row.missingDateFields?.includes('Accommodation Start Date')" class="required-input">*</span></mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="accommodation_end_date">
                        <mat-header-cell *matHeaderCellDef>Departure Date</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{ row['Accommodation End Date'] | date: 'mediumDate' }} <span *ngIf="row.missingDateFields?.includes('Accommodation End Date')" class="required-input">*</span></mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="reservation_cost">
                        <mat-header-cell *matHeaderCellDef>Reservation Cost</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row['Total Charge'] | currency }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="guest_name">
                        <mat-header-cell *matHeaderCellDef>Guest</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row["Guest's Name"] }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="owner_name">
                        <mat-header-cell *matHeaderCellDef>Owner</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row["Owners Name"] }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="created_date">
                        <mat-header-cell *matHeaderCellDef>Created Date</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ this.createdDate | date: 'mediumDate' }}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="note">
                        <mat-header-cell *matHeaderCellDef>Note</mat-header-cell>
                        <mat-cell *matCellDef="let i = index, let row">
                            <button *ngIf="row.showPropertyFlag" mat-icon-button class="flag-table-button"
                            #tooltip="matTooltip" matTooltip="Property Not Found"
                            [matTooltipPosition]="'above'" matTooltipHideDelay="250">
                                <mat-icon>error</mat-icon>
                            </button>
                            <button *ngIf="row.showReservationFlag" mat-icon-button class="flag-table-button"
                            #tooltip="matTooltip" matTooltip="Reservation Reference ID Already Exists"
                            [matTooltipPosition]="'above'" matTooltipHideDelay="250">
                                <mat-icon>error</mat-icon>
                            </button>
                            <button *ngIf="row.showMissingDateFlag" mat-icon-button class="flag-table-button"
                            #tooltip="matTooltip" matTooltip="Missing Required Date(s) - Click Edit to Fix"
                            [matTooltipPosition]="'above'" matTooltipHideDelay="250">
                                <mat-icon>error</mat-icon>
                            </button>
                            <button *ngIf="!row.showPropertyFlag && !row.showReservationFlag" mat-icon-button class="edit-table-button" (click)="editImportDataRow(row)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button class="delete-table-button" (click)="deleteImportDataRow(i, row)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{ 'show-flag': row.showPropertyFlag || row.showReservationFlag || row.showMissingDateFlag }"></mat-row>
                </table>
                @if (loading | async) {
                    <div class="d-flex justify-content-center">
                        <mat-spinner></mat-spinner>
                    </div>
                }
                <div class="row justify-content-end my-5">
                    <div class="col-3 d-flex flex-column">
                        <button mat-raised-button class="warn-button" (click)="deleteAllImportData()">
                            <mat-icon>delete</mat-icon>
                            Delete All
                        </button>
                    </div>
                    <div class="col-3 d-flex flex-column">
                        <button mat-raised-button class="action-button" (click)="importAllData()" [disabled]="!validData">
                            <mat-icon>save</mat-icon>
                            Import All
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>
    <div class="mt-3 d-block flex-nowrap justify-content-end d-sm-flex text-muted">
        <span class="required-input">*</span>&nbsp;- Invalid Data Must Be Removed Before Import
    </div>
</div>